import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const portraitSlider = $$('.portrait-slider');

if (portraitSlider.length) {
  portraitSlider.forEach(portrait => {
    const slider = new Swiperslider(
      $('.portrait-slider__item-wrapper', portrait),
      {
        container: portrait,
        sliderOptions: {
          spaceBetween: 30,
          // slideActiveClass: 'is-active',
          slideToClickedSlide: true,
        },
      }
    );

    slider.init().then(() => {
      const preloadImages = n => {
        const preloader = n => {
          setTimeout(() => {
            [...slider.swiper.slides]
              .slice(
                slider.swiper.activeIndex,
                slider.swiper.activeIndex + n + 1
              )
              .forEach(slide =>
                slide.querySelector('img').setAttribute('loading', 'eager')
              );
          }, 100);
        };

        preloader(n);

        slider.swiper.on('slideChange', () => {
          const totalSlides = slider.swiper.slides.length - 1;

          if (slider.swiper.activeIndex < totalSlides - n) {
            preloader(n);
          }
        });
      };

      preloadImages(2);
    });
  });

  const noDownloadImages = $$('.portrait-slider__image');
  noDownloadImages.forEach(image =>
    image.addEventListener('contextmenu', e => e.preventDefault())
  );
}
